// @flow

const trainingAnnual = {
  paramKey: 'training_id',
  title: 'View the Certificate',
  component: 'clients/ClientsTrainingCertificateViewModal',
  buttons: {
    cancel: {
      label: 'Cancel'
    },
    other: [
      {
        label: 'Download',
        type: 'certificate',
        icon: 'Print'
      }
    ]
  },
  initialState: null,
  requireRowId: true
};

export default trainingAnnual;
